module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Ticket Booking","availability":"Check availability","availablePaymentOptions":"Available payment options:"}}')
  delete Component.options._Ctor
}
